module.exports = [["E-mail"," Organiza��o"," Obs. N�o utilizar cabe�alho na importa��o, colocar apenas informa��es que ser�o importadas.",""],[""]]